export { default } from "./Footer";